export default __webpack_public_path__ + "static/media/antibio.f95c912d.png";